import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ArrowRight, Mail, Sparkles } from "lucide-react";

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/newsletter/subscribe", { email, name });
      toast.success(r.data.status === "already_subscribed" ? "You're already on the list — see you Monday." : "Subscribed. Next briefing arrives Monday 07:00.");
      setEmail(""); setName("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not subscribe");
    } finally { setLoading(false); }
  };

  return (
    <section className="paper-card !border-sky/30 overflow-hidden relative">
      <div className="absolute inset-0 mesh-bg opacity-60 pointer-events-none" />
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="relative px-8 md:px-14 py-14 md:py-20 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <div className="chapter-mark"><Mail className="w-3.5 h-3.5" /> The Monday Briefing</div>
          <h2 className="mt-6 font-display text-ice text-4xl md:text-5xl leading-[1.05] tracking-[-0.025em] font-extrabold">
            Every live UK rail vacancy. <span className="text-sky">One email. Monday morning.</span>
          </h2>
          <p className="mt-6 text-slate text-lg leading-[1.6] max-w-md">
            We curate the week's freshest train driver, conductor, depot, fitter, signalling and graduate roles — sent before the Monday commute.
          </p>
          <div className="mt-6 flex items-center gap-2 text-[13px] text-slate">
            <Sparkles className="w-4 h-4 text-gold" /> Joining {Math.max(120, 24)} subscribers across the UK railway industry
          </div>
        </div>
        <form onSubmit={submit} className="lg:col-span-5 space-y-3" data-testid="newsletter-form">
          <input
            placeholder="First name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-5 py-3.5 text-[14px] rounded-full bg-nav border border-line text-ice placeholder:text-slate outline-none focus:border-sky transition-colors"
            data-testid="newsletter-name"
          />
          <input
            type="email"
            required
            placeholder="you@example.co.uk"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-5 py-3.5 text-[14px] rounded-full bg-nav border border-line text-ice placeholder:text-slate outline-none focus:border-sky transition-colors"
            data-testid="newsletter-email"
          />
          <button type="submit" disabled={loading} className="w-full pill pill-primary disabled:opacity-60" data-testid="newsletter-submit">
            {loading ? "Subscribing…" : "Subscribe to the briefing"} <ArrowRight className="w-4 h-4" />
          </button>
          <p className="text-[11px] text-slate text-center">No spam. Unsubscribe in one click.</p>
        </form>
      </div>
    </section>
  );
}
